import styled from 'styled-components'

import { Colors } from '@utils/Colors'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-self: stretch;
`

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border: 1px solid ${Colors.GRAY200};
  border-radius: 12px;
  background: ${Colors.WHITE};
  cursor: pointer;

  &:focus {
    outline: 2px solid ${Colors.GRAY300};
    outline-offset: 2px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
`

export const Header = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

export const Title = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  background: ${Colors.PRIMARY500};
  color: ${Colors.WHITE};
  font-weight: 700;
  font-size: 11px;
  line-height: 16px;
`

export const Subtitle = styled.span`
  color: ${Colors.GRAY700};
  font-weight: 700;
  font-size: 15px;
  text-align: left;
`

export const Description = styled.span`
  color: ${Colors.GRAY500};
  font-size: 14px;
  margin-top: 4px;
  text-align: left;
`
